import { ApiService } from "./ApiService.js";

export class UserApiService extends ApiService {
  /**
   * @param {string} username
   * @throws {ApiError}
   * @returns {Promise<boolean>}
   */
  async block(username) {
    const response = await this.post(`/api/users/${username}/block`);
    if (response.ok) {
      return true;
    } else {
      throw this.buildApiError(response);
    }
  }

  /**
   * @param {string} username
   * @throws {ApiError}
   * @returns {Promise<boolean>}
   */
  async unblock(username) {
    const response = await this.delete(`/api/users/${username}/block`);
    if (response.ok) {
      return true;
    } else {
      throw this.buildApiError(response);
    }
  }

  /**
   * @param {string} username
   * @throws {ApiError}
   * @returns {Promise<boolean>}
   */
  async follow(username) {
    const response = await this.post(`/api/users/${username}/follow`);
    if (response.ok) {
      return true;
    } else {
      throw this.buildApiError(response);
    }
  }

  /**
   * @param {string} username
   * @throws {ApiError}
   * @returns {Promise<boolean>}
   */
  async unfollow(username) {
    const response = await this.delete(`/api/users/${username}/block`);
    if (response.ok) {
      return true;
    } else {
      throw this.buildApiError(response);
    }
  }
}
